const options = {
    SEGMENTS: [{ label: 'NSE', value: 'nse' }, { label: 'BSE', value: 'bse' }, { label: 'MCX', value: 'nsdl' }],
    EQUITY: [{ label: 'Equity', value: 'Equity' }, { label: 'F&O', value: 'FO' }, { label: 'Currency', value: 'Currency' }, { label: 'Commodity', value: 'Commodity' }],
    COMMODITY: [{ label: 'MCX', value: 'MCX' }, { label: 'NCDEX', value: 'NCDEX' }],
    MUTUAL_FUND: [{ label: 'Mutual funds', value: 'Mutualfunds' }],
    TRADINGPATTERN: [{ label: 'Intraday', value: 'intraday_pattern' }, { label: 'Positional', value: 'positional_pattern' }, { label: 'Algo', value: 'algo_pattern' }, { label: 'Investment', value: 'investment_pattern' }],
}
export default options